import api from '../library/axios';

export default {
  get_messages({ id, company_id }) {
    return api({
      url: `/api/commerce/setting/${id}/${company_id}`,
    });
  },
  update_messages({ id, data }) {
    return api({
      method: 'patch',
      url: `/api/commerce/setting/${id}`,
      data,
    });
  },
};
